var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"white",attrs:{"id":"applyButtonSection"}},[_c('b-button',{attrs:{"id":"applyButton","variant":"success"},on:{"click":function($event){return _vm.goToApplyPage()}}},[_vm._v("Solliciteer Direct")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }